import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  forwardRef
} from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR
} from "@angular/forms";
import { first, pairwise, takeUntil } from "rxjs/operators";

import { CollapseAllService } from "./collapse-all.service";
import { EditorMode, FieldType } from "./constants";

@Component({
  selector: "ta-json-editor",
  templateUrl: "./json-editor.template.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonEditorComponent),
      multi: true
    }
  ]
})
export class JsonEditorComponent
  implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy {
  EditorMode = EditorMode;
  FieldType = FieldType;

  @Input()
  rootType = FieldType.Object;

  @Input()
  rootName = "root";

  formGroup = this.fb.group({
    mode: this.fb.control(EditorMode.Tree),
    tree: this.fb.control(null)
  });

  jsonIsValid = true;

  get tree(): AbstractControl {
    return this.formGroup.get("tree")!;
  }

  get mode(): AbstractControl {
    return this.formGroup.get("mode")!;
  }

  get defaultValue(): any {
    return this.rootType === FieldType.Object ? {} : [];
  }

  constructor(
    private fb: FormBuilder,
    private collapseAllService: CollapseAllService
  ) {}

  ngOnInit(): void {
    this.initAnimateOnModeChange();
  }

  private initAnimateOnModeChange(): void {
    this.mode.valueChanges.pipe(pairwise()).subscribe(([oldMode, newMode]) => {
      if (oldMode === EditorMode.Tree && newMode === EditorMode.Text) {
        this.animate = false;
      } else if (oldMode === EditorMode.Text && newMode === EditorMode.Tree) {
        setTimeout(() => {
          this.animate = true;
        }, 0);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => (this.animate = true), 0);
  }
  animate: boolean = false;

  collapseAll(): void {
    this.collapseAllService.collapseAll();
  }

  expandAll(): void {
    this.collapseAllService.expandAll();
  }

  writeValue(val: any): void {
    val = val || this.defaultValue;
    this.formGroup.patchValue({
      mode: EditorMode.Tree,
      tree: val
    });
  }

  registerOnChange(propagateChanges: any): void {
    this.tree.valueChanges
      .pipe(takeUntil(this.onDestroyEmitter))
      .subscribe(propagateChanges);
  }

  registerOnTouched(touchCb: any): void {
    this.tree.valueChanges
      .pipe(first(), takeUntil(this.onDestroyEmitter))
      .subscribe(touchCb);
  }

  protected onDestroyEmitter = new EventEmitter<void>();
  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
    this.onDestroyEmitter.complete();
  }
}
